import { FormControl, FormGroup } from '@maplix/forms';
import { I18n, ILanguage } from './models';
import { ValidatorFn } from '@angular/forms';

export function convertToI18nFormGroups(items: I18n[], opts?: { validators?: ValidatorFn | ValidatorFn[] }) {
  return items.map((item) => {
    return new FormGroup<I18n>({
      i18n: new FormControl(item.i18n),
      value: new FormControl<string>(item.value, opts ? opts.validators : null),
    });
  });
}

export function convertToEmptyI18nFormGroups(languages: ILanguage[]) {
  if (!languages || !languages.length) {
    return [];
  }

  return languages.map((lang) => {
    return new FormGroup<I18n>({
      i18n: new FormControl(lang.code),
      value: new FormControl<string>(),
    });
  });
}
